import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import DataExtractionButtonAction from './DataExtractionButtonAction';
import { fetchPdfDataExtractionRequest } from '../../../api/pdfDataExtraction/pdfDataExtractionSlice';

function PdfDataExtractionListPageActions() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const subscription = useSelector((state) => state.org.org.subscription);
  const isPDFDataExtractionFeatureEnabled = subscription?.features?.enable_pdf_data_extraction;

  const handleOpen = () => {
    if (!checkSubscription()) {
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(fetchPdfDataExtractionRequest({ query: { page: 1, limit: 10 } })); // Refresh the list on modal close
  };

  return (
    <>
      {isPDFDataExtractionFeatureEnabled && (
        <Button variant="contained" color="primary" onClick={handleOpen}>
          + Start New Extraction
        </Button>
      )}
      <DataExtractionButtonAction open={open} onCancel={handleClose} />
      <SubscriptionModal />
    </>
  );
}

export default PdfDataExtractionListPageActions;
